exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Title\n   ========================================================================== */\n.title {\n  font-family: Roboto;\n  max-width: 100%; }\n\n/* Level\n   ========================================================================== */\n.title--level-1 {\n  font-size: 32px;\n  line-height: 46px; }\n\n.title--level-2 {\n  font-size: 26px;\n  line-height: 38px; }\n\n.title--level-3 {\n  font-size: 24px;\n  line-height: 36px; }\n\n.title--level-4 {\n  font-size: 18px;\n  line-height: 26px; }\n\n.title--level-5 {\n  font-size: 16px;\n  line-height: 22px; }\n\n.title--level-6 {\n  font-size: 14px;\n  line-height: 18px;\n  text-transform: uppercase; }\n\n/* Density\n   ========================================================================== */\n.title--density-airy.title--level-1 {\n  padding: 32px 0; }\n\n.title--density-airy.title--level-2 {\n  padding: 34px 0; }\n\n.title--density-airy.title--level-3 {\n  padding: 34px 0; }\n\n.title--density-airy.title--level-4 {\n  padding: 36px 0; }\n\n.title--density-airy.title--level-5 {\n  padding: 38px 0; }\n\n.title--density-airy.title--level-6 {\n  padding: 38px 0; }\n\n.title--density-comfortable.title--level-1 {\n  padding: 22px 0; }\n\n.title--density-comfortable.title--level-2 {\n  padding: 24px 0; }\n\n.title--density-comfortable.title--level-3 {\n  padding: 24px 0; }\n\n.title--density-comfortable.title--level-4 {\n  padding: 26px 0; }\n\n.title--density-comfortable.title--level-5 {\n  padding: 28px 0; }\n\n.title--density-comfortable.title--level-6 {\n  padding: 28px 0; }\n\n.title--density-cozy.title--level-1 {\n  padding: 12px 0; }\n\n.title--density-cozy.title--level-2 {\n  padding: 14px 0; }\n\n.title--density-cozy.title--level-3 {\n  padding: 14px 0; }\n\n.title--density-cozy.title--level-4 {\n  padding: 16px 0; }\n\n.title--density-cozy.title--level-5 {\n  padding: 18px 0; }\n\n.title--density-cozy.title--level-6 {\n  padding: 18px 0; }\n\n.title--density-compact.title--level-1 {\n  padding: 2px 0; }\n\n.title--density-compact.title--level-2 {\n  padding: 4px 0; }\n\n.title--density-compact.title--level-3 {\n  padding: 4px 0; }\n\n.title--density-compact.title--level-4 {\n  padding: 6px 0; }\n\n.title--density-compact.title--level-5 {\n  padding: 8px 0; }\n\n.title--density-compact.title--level-6 {\n  padding: 8px 0; }\n\n.title--density-none {\n  padding: 0; }\n\n/* ==========================================================================\n   Title Media Queries\n   ========================================================================== */\n@media (max-width: 767px) {\n  .title--level-1 {\n    font-size: 26px;\n    line-height: 36px; }\n  .title--level-2 {\n    font-size: 22px;\n    line-height: 28px; }\n  .title--level-3 {\n    font-size: 20px;\n    line-height: 26px; }\n  /* Density\n     ========================================================================== */\n  .title--density-airy.title--level-1 {\n    padding: 22px 0; }\n  .title--density-airy.title--level-2 {\n    padding: 24px 0; }\n  .title--density-airy.title--level-3 {\n    padding: 24px 0; }\n  .title--density-airy.title--level-4 {\n    padding: 26px 0; }\n  .title--density-airy.title--level-5 {\n    padding: 28px 0; }\n  .title--density-airy.title--level-6 {\n    padding: 28px 0; }\n  .title--density-comfortable.title--level-1 {\n    padding: 12px 0; }\n  .title--density-comfortable.title--level-2 {\n    padding: 14px 0; }\n  .title--density-comfortable.title--level-3 {\n    padding: 14px 0; }\n  .title--density-comfortable.title--level-4 {\n    padding: 16px 0; }\n  .title--density-comfortable.title--level-5 {\n    padding: 18px 0; }\n  .title--density-comfortable.title--level-6 {\n    padding: 18px 0; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};